module.exports = __webpack_public_path__ + "static/media/task-sidebar-followers-selected.1ad39650.svg";